import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {
    AMARON_PRIORITY_SCORE_RANGES,
    type AmaronPriorityLevel,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceSpecific/domain/amaron/AmaronPriority";

export {AMARON_PRIORITY_SCORE_RANGES};
export type {AmaronPriorityLevel};

export const AMARON_PRIORITY_SCORE_MIN = AMARON_PRIORITY_SCORE_RANGES.P0.min;
export const AMARON_PRIORITY_SCORE_MAX = AMARON_PRIORITY_SCORE_RANGES.P3.max;

/** Display label for each priority level (1:1 with {@link AmaronPriorityLevel}). */
export const AMARON_PRIORITY_LEVEL_FORMATTED_VALUE: Record<AmaronPriorityLevel, string> = {
    P0: "P0 | 15 min",
    P1: "P1 | 60 min",
    P2: "P2 | 6 hrs",
    P3: "P3",
};

export function formatAmaronPriorityLevel(priority: AmaronPriorityLevel): string {
    return AMARON_PRIORITY_LEVEL_FORMATTED_VALUE[priority];
}

export type AmaronPriorityMetric = {
    dispositionId: Uuid;
    utmSource: string | null;
    score: number;
    formattedValue: string;
};
